/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { get_select_one_notice } from "../../Axios";
import * as SCU from "../../style/StyleComponentUtility";
import { get_day_timestamp } from "../../Validation";

interface NoticeObject {
  ablack_notice_ID : number;
  ablack_notice_title : string;
  ablack_notice_content : string | TrustedHTML;
  ablack_notice_top_status : number;
  ablack_notice_registe : any;
  ablack_notice_modified : any;
  connection_query : string;
};

const NoticeSelectOne: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [notice, setNotice] = useState<NoticeObject>();
  const [fileList, setFileList] = useState([]);
  const [fileNameList, setFileNameList] = useState([]);

  useEffect(() => {
    get_select_one_notice(
      state.ablack_notice_ID
    ).then(result => {
      let list:any = [];
      let str_list:any = [];
      for (const item of result.files) {
        if(item) {
          let str_arr = item.split('/');
          str_list.push(str_arr[str_arr.length-1]);
          const first_char = item[0];
          if(first_char === '/') {
            const rest_str = item.slice(1);
            list.push(rest_str);
          } else {
            list.push(item);
          };
        }
      };
      setNotice(result.obj);
      setFileNameList(str_list);
      setFileList(list);
    });
  }, [state]);

  return (
    <SCU.NoticeSelectOneContainer>
      <div className="notice-title-box">
        <h1> 제목 : {notice?.ablack_notice_title}</h1>
        <button
          onClick={() => navigate("/notice")}
        >
          전체 공지사항 보기
        </button>
      </div>
      <span className="register-text">등록일 : {get_day_timestamp(notice?.ablack_notice_registe).year_month_day_time}</span>
      {notice &&
        <div
          className="notice-content-box"
          dangerouslySetInnerHTML={{__html : notice.ablack_notice_content}}
        />
      }
      {fileList.length > 0 &&
        <>
          <div className="download-announcement">
            <span>첨부 파일 다운로드</span>
          </div>
          <div className="download-box">
            {fileList.map((tmp, idx) =>
              <div
                key={idx}
                className="download-item"
              >
                <a href={`${notice?.connection_query+tmp}`} target="_blank" rel="noreferrer" >
                  {fileNameList[idx]}
                </a>
              </div>
            )}
          </div>
        </>
      }
    </SCU.NoticeSelectOneContainer>
  )
};

export default NoticeSelectOne;